export enum VentureBlockchainModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
